// extracted by mini-css-extract-plugin
export default {"desc":"Dsixth_desc__Xcuex","text":"Dsixth_text__I1R7y","Dsixth":"Dsixth_Dsixth__a+tTm","leftCell":"Dsixth_leftCell__76Q43","rightCell":"Dsixth_rightCell__qolW7"};